<template>
  <section id="section__title">
    <v-row no-gutters class="landing-container">
      <top-header />
      <v-col cols="12" class="px-3">
        <p class="font--p-3 mb-1">주말 매출도, 배달 매출도!</p>
        <p class="font-size--30 font-weight-black">오늘 바로 입금되는 <br />선정산 서비스</p>
        <p class="font--m-4">
          오래 걸리는 매출 입금 <br />
          다음 날 빠르고 정확하게 땡겨드려요
        </p>
      </v-col>
      <v-col cols="12" class="mt-10 mb-5">
        <img src="@/assets/images/landing/SectionTitle/hand-money.png" class="hand" alt="hand" />
      </v-col>
      <v-col v-if="showApply" cols="12" class="text-center px-8">
        <v-btn block class="apply-btn" :to="{ name: 'signup/agreements/nice' }">
          번개입금 신청하기
        </v-btn>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import TopHeader from '../common/layout/TopHeader.vue'
export default {
  components: {
    TopHeader,
  },
  props: {
    showApply: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
#section__title {
  .hand {
    width: 100%;
    height: 230px;
    object-fit: contain;
  }

  .apply-btn {
    background-color: #004953;
    color: white;
    height: 50px;
    font-size: 20px;
  }
}
</style>
